module.exports = __webpack_public_path__ + "media/fonts/MatterSQ-Bold-85c5e0e60d67b3da8fae9e778e1d7c98.ttf";